import React from 'react';
import PropTypes from 'prop-types';

import { DatePicker } from '@agconnections/grow-ui';

const dateRangePickerDefaultPropOnDateRangeChange = () => {};
const DateRangePicker = ({
  onDateRangeChange = dateRangePickerDefaultPropOnDateRangeChange
}) => {
  return (
    <div data-testid="daterangepicker">
      <div className="relative w-64 text-gray-400 focus-within:text-gray-600 mr-4">
        <DatePicker onChange={onDateRangeChange} isRangePicker />
      </div>
    </div>
  );
};

DateRangePicker.propTypes = {
  onDateRangeChange: PropTypes.func
};

export default DateRangePicker;
